module.exports = __webpack_public_path__ + "img/marker_optimised.81d98ed9.svg";